import React from 'react';
import { Navigate } from 'react-router-dom';

import { usePatientAuth } from '../../contexts/PatientAuthContext';

const PatientRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = usePatientAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#121212]">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#0c63e9]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/cabinet/login" replace />;
  }

  return <>{children}</>;
};

export default PatientRoute;
